import { workflowDrivenCacheActionCreator } from '../../workflow-config/utils/store.utils';
import { QcResultCategory } from '../interfaces/qcresults.interface';

export enum QualityCheckActions {
  SET_RESULTS = 'QualityCheckActions.SetResults',
  DELETE_RESULTS = 'QualityCheckActions.DeleteResults',
  INIT = 'QualityCheckActions.Init'
}

export const initResultsActionCreate = workflowDrivenCacheActionCreator<any>(QualityCheckActions.INIT);
export const setResultsActionCreator = workflowDrivenCacheActionCreator<{ [prop: string]: QcResultCategory}>(QualityCheckActions.SET_RESULTS);
export const deleteResultsActionCreate = workflowDrivenCacheActionCreator<string>(QualityCheckActions.DELETE_RESULTS);
